<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="sms"/> Viber
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex">
          <b-tab :disabled="!['owner','admin', 'tech' , 'operationsManager', 'account', 'am'].includes($store.state.user.role)">
            <template #title>
              Gateway Viber
            </template>
          </b-tab>
          <b-tab :disabled="!['owner','admin', 'tech' , 'operationsManager', 'account', 'am'].includes($store.state.user.role)">
            <template #title>
              BrandName Viber
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('viberHistory') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <gateway v-if="tabIndex === 0"></gateway>
    <viber-brand-name-list v-if="tabIndex === 1"></viber-brand-name-list>
    <history v-if="tabIndex === 2"></history>
  </main>
</template>

<script>
import ViberBrandNameList from "@/views/viber/ViberBrandNameList.vue";
import Gateway from "@/views/viber/Gateway.vue";
import History from "@/views/viber/History.vue";

export default {
  components: {ViberBrandNameList, Gateway, History},
  data() {
    return {
      tabIndex: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        viberHistory: 'Viber history',
      },
      vi: {
        viberHistory: 'Lịch sử Viber',
      }
    }
  },
}
</script>